import React, { useEffect, useState } from 'react';
import { MdEventBusy } from 'react-icons/md';
import '../../styles/Events/eventDetail.css';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../settings';
import moment from 'moment';

export default function EventDetail() {
    const navigate = useNavigate();
    const [fetchedEvent, setFetchedEvent] = useState({});
    let subscribersList = [];
    if (fetchedEvent?.subscribersList) subscribersList = JSON.parse(fetchedEvent?.subscribersList);
    const [eventFound, setEventFound] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        let path = window.location.pathname?.split('/');
        let id = path[path?.length - 1];

        // 👇️ fetch event by id
        fetch(`${BASE_URL}/events/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (response) => {
                let data = await response.json();
                setEventFound(true);

                let the_event = data?.event;
                setFetchedEvent(the_event);
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    displaySnackbar('Could not reach the servers', true);
                    setEventFound(false);
                } else {
                    displaySnackbar('Could not fetch event.', true);
                    setEventFound(false);
                }
            });
    }, []);

    return eventFound ? (
        <div className='infoboard-event-detail-container'>
            <button onClick={() => navigate(-1)} className='go-back-btn'>
                👈️ Go Back
            </button>

            <div className='header'>
                <h1>Event Detail</h1>
                {/* <button
                    onClick={() => {
                        ping_audio.play();
                        setTimeout(() => {
                            ping_audio.pause();
                        }, 1000);
                    }}
                >
                    Sign up for.
                </button> */}
            </div>

            <div className='details-content-item'>
                <span className='title'>Details</span>
                {fetchedEvent?.details?.length > 0 ? (
                    <p className='text about'>{fetchedEvent?.details}</p>
                ) : (
                    <p className='empty-text'>...</p>
                )}
            </div>

            <div className='details-content-items'>
                <div className='details-content-item'>
                    <span className='title'>Name</span>
                    {fetchedEvent?.name?.length > 0 ? (
                        <p className='text'>{fetchedEvent?.name}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Start date</span>
                    {fetchedEvent?.startDate?.length > 0 ? (
                        <p className='text'>
                            {moment(new Date(fetchedEvent?.startDate)).calendar()}
                        </p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>End Date</span>
                    {fetchedEvent?.endDate?.length > 0 ? (
                        <p className='text'>{moment(new Date(fetchedEvent?.endDate)).calendar()}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Subscribers</span>
                    {fetchedEvent?.subscribers ? (
                        <p className='text'>{fetchedEvent?.subscribers}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>priority</span>
                    {fetchedEvent?.priority?.length > 0 ? (
                        <p className='text'>{fetchedEvent?.priority}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>
            </div>

            <div className='details-content-item'>
                {console.log('subscribersList:', subscribersList)}
                <span className='title'>Subscibers List</span>
                {subscribersList &&
                Array.isArray(subscribersList) &&
                subscribersList?.length > 0 ? (
                    <ul className='qualifications-list events'>
                        {Array.isArray(subscribersList) &&
                            subscribersList?.map((item, index) => (
                                <div
                                    className='event-subscriber-item'
                                    key={`${item?.uuid}-#${index}`}
                                    onClick={() =>
                                        navigate(`/alumni/classes/${item?.classYear}/${item?.uuid}`)
                                    }
                                >
                                    <div className='event-subscribers-avatar-container'>
                                        <img
                                            src={
                                                item?.avatar
                                                    ? `${BASE_URL}/alumni/uploads/get-profile-pic/${item?.avatar}`
                                                    : require('../../images/profile-pictures/face1.jpg')
                                            }
                                            alt='event-subscriber-avatar'
                                        />
                                    </div>

                                    <div className='right'>
                                        <li className='qualifications-list-item'>
                                            {item?.firstName} {item?.lastName}
                                        </li>

                                        <li className='qualifications-list-item'>
                                            @{item?.username || `item-not-fount`}~
                                            {item?.email || `item-not-fount`}
                                        </li>
                                    </div>
                                </div>
                            ))}
                    </ul>
                ) : (
                    <p className='empty-text'>...</p>
                )}
            </div>
        </div>
    ) : (
        <div className='event-not-found-container'>
            <MdEventBusy size={100} color='#777' className='event-not-found-icon' />
            <span> event not found </span>
        </div>
    );
}
